import { Controller } from "@hotwired/stimulus";
import HSFormSearch from "../theme/hs-form-search.min";

export default class SearchController extends Controller {
  static values = {
    delay: { type: Number, default: 500 },
    url: String,
    shouldSubmit: Boolean,
  };

  connect() {
    this.lastInputValue = "";
    this.formSearch = new HSFormSearch(this.element).getItem(0);
    this.searchTimeout = null;

    this.formSearch.events = this?.formSearch?.events || {}

    this.formSearch.events.clear = () => {
      if ($('#search_users').length) {
        $('#search_users').html("<span class='text-white'>No results found!</span>")
      }
      this.#updateLinks('')
      this.#call()
    }

    this.formSearch.$el.addEventListener("input", () => {
      const normalizedValue = this.formSearch.$el.value.trimStart();
      this.formSearch.$el.value = normalizedValue;
      const value = normalizedValue.trim();

      this.formSearch.loading(true);

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        this.#search(value);
        this.formSearch.loading(false);
      }, this.delayValue);
    });
    $(this.formSearch.$el).on("change", () => {
      this.formSearch.loading(false);
    });
    this.formSearch.on("clear", () => {
      this.#updateLinks("");
      this.#call();
    });
  }

  #call() {
    const normalizedValue = this.formSearch.$el.value.trimStart();
    this.formSearch.$el.value = normalizedValue;
    const value = normalizedValue.trim();

    this.#updateLinks(value);
    this.formSearch.loading(true);

    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(async () => {
      await this.#search(value);
      this.formSearch.loading(false);
    }, this.delayValue);
  }

  async #search(search_txt) {
    if (this.shouldSubmitValue) {
      this.element.closest("form")?.requestSubmit();
      return;
    }

    this.#updateLinks(search_txt);
    if (!this.hasUrlValue) return;

    const turboRequest = (await import("../helpers/api")).turboRequest;

    await turboRequest(this.urlValue + encodeURIComponent(search_txt), {
      method: "GET",
      turboStream: true,
    });
  }

  #updateLinks(searchTxt) {
    document.querySelectorAll("#searchPosts a").forEach((link) => {
      const url = new URL(link.href);

      if (searchTxt) {
        url.searchParams.set("search", searchTxt);
      } else {
        url.searchParams.delete("search");
      }

      link.href = url.toString();
    });
  }
}
